export const API_LINKS = {
  RESET_PASSWORD_REQUEST: 'public/reset_password_request',
  RESET_PASSWORD_VALIDATE: 'public/reset_password_validate',
  RESET_PASSWORD_SET: 'public/reset_password_set',
};
